























































































































import { Component, Vue } from "vue-property-decorator";
import { sceneModule } from "../../store/scene";
import ApolloClient, { serverBase } from "../../apollo";
import gql from "graphql-tag";
import ActorSelector from "../ActorSelector.vue";
import IActor from "../../types/actor";
import StudioSelector from "../../components/StudioSelector.vue";

@Component({
  components: {
    ActorSelector,
    StudioSelector,
  },
})
export default class SceneToolbar extends Vue {
  editDialog = false;
  validEdit = false;
  editName = "";
  editDescription = "";
  editStreamLinks = null as string | null;
  editActors = [] as IActor[];
  editStudio = null as any;
  editReleaseDate = null as number | null;

  sceneNameRules = [(v) => (!!v && !!v.length) || "Invalid scene name"];

  removeDialog = false;
  deleteImages = false;
  removeLoader = false;

  watch(url: string) {
    if (!this.currentScene) return;

    var win = window.open(url, "_blank");
    if (win) win.focus();
  }

  getDomainName(url: string) {
    return new URL(url).hostname.split(".").slice(0, -1).join(".");
  }

  remove() {
    if (!this.currentScene) return;

    this.removeLoader = true;
    ApolloClient.mutate({
      mutation: gql`
        mutation($ids: [String!]!, $deleteImages: Boolean) {
          removeScenes(ids: $ids, deleteImages: $deleteImages)
        }
      `,
      variables: {
        ids: [this.currentScene._id],
        deleteImages: this.deleteImages,
      },
    })
      .then((res) => {
        this.removeDialog = false;
        this.$router.replace("/scenes");
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        this.removeLoader = false;
      });
  }

  openRemoveDialog() {
    this.removeDialog = true;
  }

  editScene() {
    if (!this.currentScene) return;

    const streamLinks = (this.editStreamLinks || "").split("\n").filter(Boolean);

    ApolloClient.mutate({
      mutation: gql`
        mutation($ids: [String!]!, $opts: SceneUpdateOpts!) {
          updateScenes(ids: $ids, opts: $opts) {
            _id
            labels {
              _id
              name
            }
            studio {
              _id
              name
              thumbnail {
                _id
              }
            }
          }
        }
      `,
      variables: {
        ids: [this.currentScene._id],
        opts: {
          name: this.editName,
          description: this.editDescription,
          streamLinks,
          actors: this.editActors.map((a) => a._id),
          studio: this.editStudio ? this.editStudio._id : null,
          releaseDate: this.editReleaseDate,
        },
      },
    })
      .then((res) => {
        sceneModule.setName(this.editName.trim());
        sceneModule.setDescription(this.editDescription.trim());
        sceneModule.setStreamLinks(streamLinks);
        sceneModule.setActors(this.editActors);
        sceneModule.setStudio(res.data.updateScenes[0].studio);
        sceneModule.setReleaseDate(this.editReleaseDate);
        sceneModule.setLabels(res.data.updateScenes[0].labels);
        this.editDialog = false;
      })
      .catch((err) => {
        console.error(err);
      });
  }

  openEditDialog() {
    if (!this.currentScene) return;

    this.editName = this.currentScene.name;
    this.editDescription = this.currentScene.description || "";
    this.editStreamLinks = this.currentScene.streamLinks.join("\n");
    this.editActors = JSON.parse(JSON.stringify(this.currentScene.actors));
    this.editDialog = true;
    this.editStudio = this.currentScene.studio;
    this.editReleaseDate = this.currentScene.releaseDate;
  }

  favorite() {
    if (!this.currentScene) return;

    ApolloClient.mutate({
      mutation: gql`
        mutation($ids: [String!]!, $opts: SceneUpdateOpts!) {
          updateScenes(ids: $ids, opts: $opts) {
            favorite
          }
        }
      `,
      variables: {
        ids: [this.currentScene._id],
        opts: {
          favorite: !this.currentScene.favorite,
        },
      },
    }).then((res) => {
      sceneModule.setFavorite(res.data.updateScenes[0].favorite);
    });
  }

  bookmark() {
    if (!this.currentScene) return;

    ApolloClient.mutate({
      mutation: gql`
        mutation($ids: [String!]!, $opts: SceneUpdateOpts!) {
          updateScenes(ids: $ids, opts: $opts) {
            bookmark
          }
        }
      `,
      variables: {
        ids: [this.currentScene._id],
        opts: {
          bookmark: this.currentScene.bookmark ? null : Date.now(),
        },
      },
    }).then((res) => {
      sceneModule.setBookmark(res.data.updateScenes[0].bookmark);
    });
  }

  get currentScene() {
    return sceneModule.current;
  }

  get currentSceneURL() {
    if (this.currentScene)
      return `${serverBase}/media/scene/${this.currentScene._id}?password=${localStorage.getItem(
        "password"
      )}`;
  }

  mounted() {
    /* window.addEventListener("keydown", ev => {
      if (ev.keyCode === 70) {
        this.favorite();
      } else if (ev.keyCode === 66) {
        this.bookmark();
      }
    }); */
  }
}
